import React, { useState, useEffect, useRef } from "react";

import { TextField, FormControlLabel, Checkbox } from "@mui/material";

export default function ScannerInput({ onScanComplete }) {
  const [data, setData] = useState("");
  const [isChecked, setisChecked] = useState(true);
  const inputRef = useRef(null);

  useEffect(() => {
    let timeout = isChecked ? 100 : 500;
    const timeoutId = setTimeout(async () => {
      if (data.length > 5) {
        onScanComplete(data);
        setData("");
        inputRef.current?.focus();
      }
    }, timeout);
    return () => clearTimeout(timeoutId);
  }, [data, isChecked]);

  const onChange = (e) => {
    setData(e.target.value);
  };

  return (
    <>
      <TextField
        value={data}
        size="small"
        onChange={onChange}
        inputRef={inputRef}
        placeholder="Scanner input"
        variant="outlined"
        fullWidth
        sx={{ mb: 1 }} // Reduced from mb:2 to mb:1
      />

      <FormControlLabel
        control={
          <Checkbox
            checked={isChecked}
            size="small"
            onChange={(e) => setisChecked(e.target.checked)}
            color="primary"
          />
        }
        label="Auto"
        sx={{
          mt: 0, // Removed top margin
          "& .MuiFormControlLabel-label": {
            fontSize: "0.875rem", // Optional: match label size to checkbox
          },
        }}
      />
    </>
  );
}
